import React from "react";

// import { Container } from './styles';

const Error: React.FC = () => {
  return <div>ERROR 404</div>;
};

export default Error;
